export default __webpack_public_path__ + "static/desk03-b9bbba9a25e09b64520610881f709571.png";